import { useQuery } from 'react-query';

import {
  CorporateSubscriberCirclePartner,
  fetchCoporateSubscriberCirclePartners,
} from '../utils/backend-api/partners';

export const CSC_PARTNERS_KEY = 'CSC_PARTNERS';

export default function usePartnersCorporateSubscriberCircle() {
  const { data: cscPartners, isLoading: isLoadingCscPartners } = useQuery<
    CorporateSubscriberCirclePartner[]
  >(CSC_PARTNERS_KEY, async () => await fetchCoporateSubscriberCirclePartners());
  return { cscPartners, isLoadingCscPartners };
}
